import { iEnv } from "./interface";

export const environment: iEnv = {
	envName: "production",
	dev: false,
	production: true,
	debug: false,
	api: "https://api.bolaopenacova.com",
	analytics_api: "https://analytics.bolaopenacova.com",
	title: "Bolão Pé na Cova 3.0",
	recaptcha: "6LeRHXoqAAAAAA0YdnIyjhWxJ1i2AEs5LGL_3_by",
	sentry: "https://ec121baa91cf9c5744308fb5772a89e2@o4510704667721728.ingest.us.sentry.io/4510709327527936",
};